__turbopack_context__.v({
  "cardGroup": "BlockCardGroup-module-scss-module__ukE-ua__cardGroup",
  "cardGroupCarousel": "BlockCardGroup-module-scss-module__ukE-ua__cardGroupCarousel",
  "cta": "BlockCardGroup-module-scss-module__ukE-ua__cta",
  "eyebrow": "BlockCardGroup-module-scss-module__ukE-ua__eyebrow",
  "fade-in": "BlockCardGroup-module-scss-module__ukE-ua__fade-in",
  "featured": "BlockCardGroup-module-scss-module__ukE-ua__featured",
  "featuredBg": "BlockCardGroup-module-scss-module__ukE-ua__featuredBg",
  "flushBottom": "BlockCardGroup-module-scss-module__ukE-ua__flushBottom",
  "flushTop": "BlockCardGroup-module-scss-module__ukE-ua__flushTop",
  "inlineIntroContent": "BlockCardGroup-module-scss-module__ukE-ua__inlineIntroContent",
  "inlineIntroContentInner": "BlockCardGroup-module-scss-module__ukE-ua__inlineIntroContentInner",
  "inlineIntroSmall": "BlockCardGroup-module-scss-module__ukE-ua__inlineIntroSmall",
  "latest": "BlockCardGroup-module-scss-module__ukE-ua__latest",
  "products": "BlockCardGroup-module-scss-module__ukE-ua__products",
  "recipeProducts": "BlockCardGroup-module-scss-module__ukE-ua__recipeProducts",
  "recipes": "BlockCardGroup-module-scss-module__ukE-ua__recipes",
});
